<div class="tab-navigation" [ngClass]="{'large': (userService.user$ | async).getServiceCaseTabLineCount() === 4}">
  <div class="case-bar-controls ms-8x me-2x">
    <div class="case-search-box" [class.expanded]="vehicleSearchService.advancedSearchVisible()">
      <div class="case-search-field-container">
        <ds-form-field class="case-search-field" [disabled]="loading">
          <input ds-input ds-form-validation type="text" autocomplete="off"
                 name="vehicle-search-input"
                 maxlength="36"
                 #searchInputModel="ngModel"
                 [(ngModel)]="searchInput"
                 [pattern]="searchInputValidationRegexp"
                 [placeholder]="(loading ? 'vehicle.loadingVehicle' : 'case.searchInputPlaceHolder') | translate"
                 (focus)="searchSuggestions.show()"
                 (click)="searchSuggestions.show()"
                 (keyup.enter)="searchAndOpenServiceCase(searchInputModel)"
                 (keydown)="searchInputModel.control.markAsUntouched()"
                 [attr.disabled]="loading ? true : null"/>
          <ds-error>{{ 'case.vinValidationError' | translate }}</ds-error>
          <button ds-button ds-after icon="search" class="case-search-button"
                  (click)="searchAndOpenServiceCase(searchInputModel)"
                  [disabled]="loading">
          </button>
        </ds-form-field>
        <app-vehicle-search-suggestions #searchSuggestions
                                        (suggestionSelected)="selectSearchSuggestion($event, searchInputModel)">
        </app-vehicle-search-suggestions>
      </div>
      @if (keyPoolButtonVisible) {
        <button ds-button icon="key" class="key-pool-search-button"
                (click)="showSearchOverlayKeyPool()"
                [disabled]="loading">
        </button>
      }
      <button ds-toggle-button class="advanced-search-button" (click)="toggleAdvancedSearchOverlay()"
              [checked]="advancedSearchVisible()"
              [disabled]="loading">{{ 'case.vehicleSearchAdvanced' | translate }}
      </button>
    </div>
  </div>

  <div class="case-tab-container" #tabContainer (mouseout)="updateTabWidth()" (focusout)="updateTabWidth()">
    @for (serviceCase of serviceCaseHolder.serviceCases; track serviceCase; let i = $index) {
      <div class="case-tab-with-tooltip me-2x">
        <app-service-case-tab
          [ngStyle]="{'width': tabWidth + 'px'}"
          [ngClass]="{'is-inactive' : serviceCaseHolder.activeServiceCaseIndex !== i || loading || vehicleSearchService.advancedSearchVisible(), 'no-gradient-and-padding' : tabWidth < 18}"
          [serviceCase]="serviceCase"
          [user]="userService.user$ | async"
          [isLarge]="(userService.user$ | async)?.getServiceCaseTabLineCount() === 4"
          tabindex="0"
          role="button"
          (click)="onCaseTabClick(serviceCase)"
          (keydown.enter)="onCaseTabClick(serviceCase)"
          (keydown.space)="$event.preventDefault(); onCaseTabClick(serviceCase)"
          (mouseenter)="onTabMouseOver($event)"
        ></app-service-case-tab>
        @if (tabWidth < 290) {
          <app-service-case-tab
            class="case-tab-tooltip"
            [isTooltip]="true"
            [serviceCase]="serviceCase"
            [user]="userService.user$ | async"
            [isLarge]="(userService.user$ | async)?.getServiceCaseTabLineCount() === 4"
          ></app-service-case-tab>
        }
      </div>
    }
  </div>

  @if (serviceCaseHolder.getActiveCase() && !shortListViewState().visible) {
    <div class="shopping-cart-container p-3x">
      <app-shopping-cart-button [active]="false" (buttonClicked)="showShortList()"></app-shopping-cart-button>
    </div>
  }
</div>

<app-vehicle-selection #vehicleSelectionOverlay/>
<app-case-selection #caseSelectionOverlay/>
<app-customer-selection-overlay/>

@if (customerLanguagePopupRequired()) {
  <app-customer-language-popup/>
}
